export default "__VITE_ASSET__CkmYCmZa__"